import React from 'react';
import type { PersonImageProps } from './PersonImage';
import { PersonImage } from './PersonImage';
import { AccessibleClickableContainer } from '../accessibility';
import { Icon } from './Icon';

/**
 * Properties for a {@link PersonImageAction} component.
 *
 */
export type PersonImageActionEmptyState = Exclude<
  PersonImageProps['emptyState'],
  'nameCircle'
>;

export interface PersonImageActionProps
  extends Omit<PersonImageProps, 'emptyState'> {
  emptyState?: PersonImageActionEmptyState;
  clickAction?: () => void;
  ariaLabel: string;
  variant: 'edit' | 'delete';
}

/**
 * PersonImageAction Button
 */

export const PersonImageAction = ({
  image = '',
  loadImage,
  emptyState = 'defaultAvatar',
  firstName,
  lastName,
  alt,
  clickAction,
  ariaLabel,
  variant,
  ...props
}: Readonly<PersonImageActionProps>): React.JSX.Element => {
  if (clickAction) {
    return (
      <AccessibleClickableContainer
        className={'ehs-person-image-' + variant}
        aria-label={ariaLabel}
        onClick={() => clickAction()}
        {...props}
      >
        <PersonImage
          image={image}
          loadImage={loadImage}
          emptyState={emptyState}
          scale={props.scale}
          alt={alt}
        />
        {variant === 'delete' && <span>{firstName + ' ' + lastName}</span>}
        <Icon
          aria-label=""
          className={'image-icon-' + variant}
          iconName={variant === 'delete' ? 'shui-cancel' : 'shui_edit'}
        />
      </AccessibleClickableContainer>
    );
  } else {
    return (
      <div className={'ehs-person-image-item-' + variant}>
        <PersonImage
          {...props}
          image={image}
          loadImage={loadImage}
          emptyState={emptyState}
          aria-label={ariaLabel}
          alt={alt}
        />
      </div>
    );
  }
};
